import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
	0% {
		background-position: -200% 0;
	}
	100% {
		background-position: 200% 0;
	}
`;

export const SkeletonBlock = styled.div`
	width: ${(props) => props.$width || '100%'};
	height: ${(props) => props.$height || '1rem'};
	min-width: ${(props) => props.$minWidth || '0'};
	min-height: ${(props) => props.$minHeight || '0'};
	border-radius: ${(props) => props.$radius || '8px'};
	background: linear-gradient(
		90deg,
		rgba(48, 32, 62, 0.95) 0%,
		rgba(140, 70, 170, 0.55) 45%,
		rgba(48, 32, 62, 0.95) 90%
	);
	background-size: 200% 100%;
	animation: ${shimmer} 1.2s ease-in-out infinite;
	flex-shrink: 0;
`;
